import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { ModalSize } from "./modal.js";

/** Foreground layout container for modal dialogs. */
export const ModalStage: FC<{ size?: ModalSize; children: ReactNode }> = (
  props,
) => (
  <div
    className={twMerge(
      "absolute inset-0 z-10 overflow-y-auto",
      // A full-size modal scrolls internally rather than growing the stage.
      props.size === ModalSize.Full && "overflow-hidden",
    )}
  >
    <div
      className={twMerge(
        "flex min-h-full flex-col items-center justify-center p-4 sm:p-0",
        // The gutter a full-size modal fills. `h-full` makes this height
        // definite so the modal can resolve its own `h-full` against it.
        props.size === ModalSize.Full && "h-full p-5 sm:p-12",
      )}
    >
      {props.children}
    </div>
  </div>
);
